// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3sbiA","footer":"ChangeClinic_footer__2lTdU"};